import React, { Component } from "react";
import { connect } from "react-redux";

import ProjectForm from "./form";
import { createProject } from "../actions";
import { Form } from "react-final-form";

import SlidingPane from "modules/5_view_helpers/web/SlidingPane";
import _ from "lodash";

function mapStateToProps(state) {
  return {};
}

class NewProjectSliding extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.successfullySubmitted = this.successfullySubmitted.bind(this);

    this.state = {
      isOpen: this.props.isOpen,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const prevIsOpen = prevState.isOpen;
    const { isOpen } = this.props;

    if (prevIsOpen != isOpen) {
      this.setState({ isOpen: isOpen });
    }
  }

  submitForm(values) {
    const createRequest = this.props.createProject(values);
    createRequest.then(this.successfullySubmitted);
  }

  successfullySubmitted(response) {
    const new_id = _.get(response, "value.data.id");
    const { toggle } = this.props;
    toggle();
    toastr.success("Created New Project");
    if (this.props.onSuccess && new_id) {
      this.props.onSuccess(new_id);
    }
  }

  render() {
    const { isOpen } = this.state;
    const { toggle } = this.props;

    return (
      <SlidingPane isOpen={isOpen} onRequestClose={toggle} title="New Project" width="50%">
        <Form component={ProjectForm} formLabel="Create" onSubmit={this.submitForm} cancelFunction={toggle} {...this.props} />
      </SlidingPane>
    );
  }
}

export default connect(mapStateToProps, { createProject })(NewProjectSliding);
